export class OrderUserCriteria {
  constructor(public userId: string, public types: OrderParticipantType[]) {}
}

export enum OrderParticipantType {
  Driver = 'Driver',
  Creator = 'Creator',
  Receiver = 'Receiver',
  Completer = 'Completer',
}
